import coreForms from "@storefront/core/modules/forms/store/";
import { loadForms } from "@storefront/core/data-resolver/forms";

const state = () => ({
    ...coreForms.state(),

    customForm: [],
});
const actions = {
    ...coreForms.actions,
    /**
 * Load the dynamic forms
 *
 */
    loadForms({ dispatch }) {
        dispatch("loadContactForm");
        dispatch("loadProductForm");
        dispatch("loadCategoryForm");
        dispatch("loadCustomForm");
    },
    async loadCustomForm({ commit }) {
        const form = await loadForms("custom");
        commit("setCustomForm", form);
    },
}
const mutations = {
    ...coreForms.mutations,

    setCustomForm(state, payload) {
        state.customForm = payload;
    }
};
const getters = {
    ...coreForms.getters,

    getCustomForm: (state) => state.customForm,
};

// export this module.
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
